import { isFunction } from 'lodash';
import * as types from '../mutation-types';

/*
 * Modal states
 */
const state = {
  show: false,
  html: null,
  props: {
    class: null,
    title: null,
    closeOnClickModal: false,
  },
  callbacks: {
    close: null,
  },
};

/*
 * Modal getters
 */
const getters = {
  show(state) {
    return state.show;
  },

  html(state) {
    return state.html;
  },

  modalTitle(state) {
    return state.props.title;
  },

  modalClass(state) {
    return state.props.class;
  },

  closeOnClickModal(state) {
    return state.props.closeOnClickModal;
  },
};

/*
 * Modal mutations
 */
const mutations = {
  [types.SHOW_MODAL](state, { html, props }) {
    state.show = true;

    state.html = html || null;
    state.props = props || state.props;
  },

  [types.SET_CLOSE_CALLBACK](state, handler) {
    state.callbacks.close = handler;
  },

  [types.CLOSE_MODAL](state, native = true) {
    state.show = false;
    state.html = null;

    if(isFunction(state.callbacks.close)) {
      state.callbacks.close.call(null, state.props, native);
      state.callbacks.close = null;
    }
  },
};

/*
 * Modal actions
 */
const actions = {};

/**
 * Modal Storage
 */
export default {
  namespaced: true,

  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./templates/floor/assets/js/VueApplication/Storage/modules/modal.js